import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Users, 
  Video, 
  ListOrdered, 
  MapPin, 
  DollarSign, 
  Bell, 
  LogOut, 
  User, 
  ChevronDown,
  FileText,
} from 'lucide-react';
import useSideBar from './useSideBar';

interface NavItem {
  name: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
  translationKey: string;
}

const Sidebar = () => {
  const [t] = useTranslation();
  const { T, logout } = useSideBar();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const navigation: NavItem[] = [
    { 
      name: 'Dashboard', 
      href: '/dashboard', 
      icon: LayoutDashboard, 
      translationKey: 'dashboard.title' 
    },
    { 
      name: 'Vidéographes', 
      href: '/dashboard/videographers', 
      icon: Users, 
      translationKey: 'dashboard.videoGrapherPage.videoGrapher' 
    },
    { 
      name: 'Vidéos', 
      href: '/dashboard/videos', 
      icon: Video, 
      translationKey: 'dashboard.videosPage.title' 
    },
    { 
      name: 'Catégories Tours', 
      href: '/dashboard/categories-tour', 
      icon: ListOrdered, 
      translationKey: 'dashboard.CategoriesTourPage.title' 
    },
    { 
      name: 'Tours', 
      href: '/dashboard/tours', 
      icon: MapPin, 
      translationKey: 'dashboard.TourPage.title' 
    },
    { 
      name: 'Retraits', 
      href: '/dashboard/withdraw', 
      icon: DollarSign, 
      translationKey: 'dashboard.withdrawsPage.title' 
    },
    { 
      name: 'Factures', 
      href: '/dashboard/invoices', 
      icon: FileText, 
      translationKey: 'dashboard.invoicesPage.title' 
    },
    { 
      name: 'Notifications', 
      href: '/dashboard/notification', 
      icon: Bell, 
      translationKey: 'dashboard.NotificationPage.title' 
    },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-container">
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <div className="sidebar-logo-icon">
              <LayoutDashboard size={20} />
            </div>
            <span className="sidebar-logo-text">Ream Dashboard</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          {navigation.map((item) => {
            // Détection améliorée pour supporter les routes imbriquées
            const isActive = 
              location.pathname === item.href || 
              (item.href !== '/dashboard' && location.pathname.startsWith(item.href));
            const Icon = item.icon;

            return (
              <Link
                key={item.name}
                to={item.href}
                className={`sidebar-nav-item ${isActive ? 'active' : ''}`}
              >
                <Icon className="sidebar-nav-icon" size={20} />
                {t(item.translationKey)}
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <button 
              className="sidebar-user-trigger"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <div className="sidebar-user-info">
                <div className="sidebar-user-avatar">
                  AD
                </div>
                <div className="sidebar-user-details">
                  <p className="sidebar-user-name">Admin</p>
                  <p className="sidebar-user-role">Administrateur</p>
                </div>
              </div>
              <ChevronDown 
                className={`sidebar-user-chevron ${dropdownOpen ? 'open' : ''}`} 
                size={16} 
              />
            </button>
            
            {dropdownOpen && (
              <div className="sidebar-dropdown">
                <button className="sidebar-dropdown-item">
                  <User size={16} />
                  <span>Profil</span>
                </button>
                <div className="sidebar-dropdown-separator" />
                <button 
                  className="sidebar-dropdown-item logout" 
                  onClick={logout}
                >
                  <LogOut size={16} />
                  <span>{T('ProfileContainer.deconnexion')}</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
